import axios from './axios';

export const authService = {
  checkAuthLink: (data) => {
    return axios.post('api/v2/auth/one-time-auth', data);
  },
  resetPassword: (data) => {
    return axios.post('api/v2/auth/forgot-password', data);
  },
  newPassword: (data) => {
    return axios.post('api/v2/auth/password-reset', data);
  }
};
